import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ButtonComponent),
      multi: true
    }
  ]
})
export class ButtonComponent implements OnInit {

 
  public isDisabled = false;
  @Input() value: any = '';

  @Input() label: any =  '';
  @Input() disabel = false;
  @Input() mobile = false;
  @Input() outline = false;
  @Input() icon: any =  '';
  @Input() positionIcon: any =  '';
  @Input() colorBg: any =  'var(--ion-color-primary)';
  @Input() colorFont: any =  '';
  @Input() device: any =  'tabs';
  @Input() loading = false;
  @Input() mode: any =  'normal';
  @Input() pathImage: any =  '';

  
  @Output() ngModelChange = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {

  }

  
  changed = (value: any): void => { }
  touched = (): void => { console.log('halo touch'); };

  doInput(event: any) {
    const value = event.target.value;
    this.changed(value);
    this.ngModelChange.emit(value);
  }

  registerOnChange(fn: any): void {
    this.changed = fn;
  }

  registerOnTouched(fn: any): void {
    this.touched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(value: any) {
    this.value = value;
  }


}
